import { render, staticRenderFns } from "./User-profile.vue?vue&type=template&id=99e6cbe4&"
import script from "./User-profile.vue?vue&type=script&lang=js&"
export * from "./User-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports